export default "__VITE_ASSET__DKy7HdAB__"